
<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{$t(pagetitle)}}</h3>
      </div>

      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t('apartment.resident')}}</label>
              <select
                v-model="selectedCustomer"
                :disabled="disableResidentOption"
                class="form-control"
                style="width: 100%;"
              >
                <option
                  v-for="customer in customer_list"
                  v-bind:key="customer.id"
                  class="form-control"
                  v-bind:value="customer.id"
                >{{ customer.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t('customer.fullname')}}</label>
              <input
                v-model="customer.fullname"
                :disabled="true"
                type="text"
                class="form-control"
                id="fullname"
                placeholder
              >
            </div>
            <!-- /fullname -->
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t('customer.phone')}}</label>
              <input
                v-model="customer.phone"
                :disabled="true"
                type="text"
                class="form-control"
                id="phone"
                placeholder
              >
            </div>
            <!-- /phone -->
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="email">{{$t('customer.email')}}</label>
              <input
                v-model="customer.email"
                :disabled="true"
                type="email"
                class="form-control"
                id="email"
                placeholder
              >
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t('apartment.under_age')}}</label>
              <b-form-select
                :options="underAgeOptions"
                :disabled="disableUnderAge"
                v-model="underAge"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t('apartment.resident_status')}}</label>
              <b-form-select
                :options="residentStatusOptions"
                required
                v-model="residence_status"
                v-on:change="onChangeResidentStatus"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t('apartment.relationship')}}</label>
              <b-form-select
                :options="relationshipOptions"
                required
                v-model="relationship"
                :disabled="disableRelationshipOption"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t('apartment.relationship_to')}}</label>
              <select
                v-model="selectedCustomerRelationTo"
                :disabled="disableRelationshipToOption"
                class="form-control"
                style="width: 100%;"
              >
                <option
                  v-for="customer in relationship_to_customer_list"
                  v-bind:key="customer.id"
                  class="form-control"
                  v-bind:value="customer.id"
                >{{ customer.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t('apartment.relationship_note')}}</label>
              <input
                v-model="relationship_note"
                type="text"
                class="form-control"
                id="w_figure"
                placeholder
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group" v-if="!hasOwner">
              <label>{{$t('apartment.is_owner')}}</label>
              <b-form-select
                :options="mainOwnerOptions"
                :disabled="disableOwnerOption"
                v-on:change="mainOwnerSelected"
                required
                v-model="mainOwner"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group" v-if="!hasTenant">
              <label>{{$t('apartment.is_tenant')}}</label>
              <b-form-select
                :options="tenantOptions"
                v-on:change="tenantSelected"
                v-model="tenant"
                :disabled="disableTenantOption"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t('apartment.main_contact')}}</label>
              <b-form-select
                :options="mainContactOptions"
                required
                v-model="mainContact"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="e_figure">{{$t('apartment.e_figure')}}</label>
              <input
                v-model="e_figure"
                type="text"
                class="form-control"
                id="e_figure"
                placeholder="0"
                :disabled="disableEFigure"
              >
            </div>
            <!-- /electric start figure -->
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="w_figure">{{$t('apartment.w_figure')}}</label>
              <input
                v-model="w_figure"
                :disabled="disableWFigure"
                type="text"
                class="form-control"
                id="w_figure"
                placeholder="0"
              >
            </div>
            <!-- /electric water figure -->
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t('apartment.move_in')}}</label>
              <date-picker v-model="date_move_in" :config="options"></date-picker>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t('apartment.move_out')}}</label>
              <date-picker v-model="date_move_out" :config="options"></date-picker>
            </div>
            <!-- second row end -->
          </div>
          <div class="col-md-4"></div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-labeled btn-danger"
      @click="onResidentCancel"
      style="margin-right: 5px;"
    >
      <span class="btn-label">
        <i class="glyphicon glyphicon-remove"></i>
      </span>
      {{$t('common.cancel')}}
    </button>

    <button
      type="button"
      class="btn btn-labeled btn-success pull-right"
      @click="onResidentSubmit"
      style="margin-right: 5px;"
    >
      <span class="btn-label">
        <i class="glyphicon glyphicon-ok"></i>
      </span>
      {{$t('common.save')}}
    </button>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import utils from '@/lib/utils'
import constants from "@/lib/constantsData";

export default {
  name: "ResidentAdd",
  props: {
    item: Object,
    default: () => {}
  },
  data() {
    return {
      // itemData: this.item,
      residentStatusOptions: [
        { text: "Select One", value: null },
        { text: "S", value: 1 },
        { text: "L", value: 2 }
      ],
      mainContact: false,
      mainContactOptions: [
        { text: "Select One", value: null },
        { text: "Yes", value: true },
        { text: "No", value: false }
      ],
      mainOwner: false,
      mainOwnerOptions: [
        { text: "Select One", value: null },
        { text: "Yes", value: true },
        { text: "No", value: false }
      ],
      underAge: false,
      underAgeOptions: [
        { text: "Select One", value: null },
        { text: "Yes", value: true },
        { text: "No", value: false }
      ],
      tenant: false,
      tenantOptions: [
        { text: "Select One", value: null },
        { text: "Yes", value: true },
        { text: "No", value: false }
      ],
      relationship: null,
      relationshipOptions: constants.relationshipOptions,
      w_figure: null,
      e_figure: null,
      selectedCustomer: null,
      relationship_note: "",

      pagetitle: "New Resident",
      apartment: {
        id: 0,
        apartment_code: "",
        size: "",
        rental_status: null,
        service: null
      },
      customer: {
        id: 0,
        userid: null,
        full_name: "",
        phone: "",
        email: ""
      },
      options: {
        format: "DD-MMM-YYYY"
      },
      date_move_in: "2019-04-16T06:00:00Z",
      date_move_out: null, //"2019-04-16T06:00:00Z",
      customer_list: [],
      relationship_to_customer_list: [],
      selectedCustomerRelationTo: null,
      final_data: [],
      resident_list_data: [],
      hasOwner: null,
      hasTenant: null,
      resident_ids: [],
      main_contact_id: [],
      disableResidentOption: false,
      edit_id: null,
      disableRelationshipToOption: false,
      disableTenantOption: false,
      disableRelationshipOption: false,
      disableOwnerOption: false,
      disableWFigure: true,
      disableEFigure: true,
      disableUnderAge: true,
      owner_detail: {},
      relation_to_owner_list: [],
      residence_status: null
    };
  },

  watch: {
    item: function() {
      let id = this.$route.params.id;
      if (this.item.actionType === 1) {
        this.apartment.id = id;
        this.pagetitle = "apartment.edit_resident";
        this.GET_APARTMENT_DETAIL({ id: id });
        const data = {
          params: {
            page: 1,
            apartment: id
          }
        };
        this.GET_RESIDENT_LIST(data);
        this.GET_RESIDENT_DETAIL({ id: this.item.id });
      }
    },
    APARTMENT_DETAIL_DATA: function() {
      this.apartment.id = this.APARTMENT_DETAIL_DATA.id;
      this.apartment.apartment_code = this.APARTMENT_DETAIL_DATA.apartment_code;
      this.apartment.size = this.APARTMENT_DETAIL_DATA.size;
      this.apartment.rental_status = this.APARTMENT_DETAIL_DATA.rental_status;
    },
    GET_RESIDENT_DATA: function() {
      this.relationship_to_customer_list = [];
      this.GET_RESIDENT_DATA.forEach(resident => {
        let resident_data = {};
        this.resident_ids.push(resident.resident.id);
        resident_data["id"] = resident.resident.id;
        resident_data["first_name"] = resident.resident.first_name;
        resident_data["last_name"] = resident.resident.last_name;
        resident_data["is_owner"] = resident.isOwner;
        resident_data["main_contact"] = resident.isMainContact;
        this.resident_list_data.push(resident_data);
        if (resident.relationship_to !== null) {
          this.relation_to_owner_list.push(resident.relationship_to["id"]);
        }

        // if(this.item.actionType === 1){
        if (resident.isOwner === "Yes") {
          this.hasOwner = false;
          this.disableOwnerOption = true;
          this.owner_id = resident.resident.id;
        }
        if (resident.isTenant === "Yes") {
          this.hasTenant = false;
          this.disableTenantOption = true;
        }

        // } else {
        //   if(resident.isOwner === 'Yes'){
        //     this.hasOwner = true
        //     this.owner_id = resident.resident.id
        //   }
        //   if(resident.isTenant === 'Yes'){
        //     this.hasTenant = true
        //   }
        // }

        if (
          resident.isOwner === "Yes" ||
          resident.isMainContact === "Yes" ||
          resident.isTenant === "Yes"
        ) {
          let tmp_dict = {};
          (tmp_dict["username"] = resident.resident.username),
            (tmp_dict["id"] = resident.resident.id);
          tmp_dict["name"] =
            resident.resident.first_name + " " + resident.resident.last_name;
          if (this.selectedCustomer !== resident.resident.id) {
            this.relationship_to_customer_list.push(tmp_dict);
          }
        }
        if (
          resident.isMainContact === "Yes" &&
          !this.main_contact_id.includes(resident.resident.id)
        ) {
          this.main_contact_id.push(resident.resident.id);
        }
      });
      this.disableRelationshipToOption =
        this.relationship_to_customer_list.length === 0 ? true : false;
      this.disableRelationshipOption = this.disableRelationshipToOption;
    },

    GET_CUSTOMER_DATA: function() {
      this.GET_CUSTOMER_DATA.forEach(customer => {
        let tmp_dict = {};
        (tmp_dict["username"] = customer.username),
          (tmp_dict["id"] = customer.id);
        tmp_dict["name"] = customer.firstname + " " + customer.lastname;
        if (!this.resident_ids.includes(customer.id)) {
          this.customer_list.push(tmp_dict);
        }
      });
    },
    selectedCustomer: function() {
      this.GET_CUSTOMER_DETAIL({ id: this.selectedCustomer });
      if (this.item.actionType !== 1) {
        if (
          this.main_contact_id.length === 3 ||
          this.main_contact_id.length > 3
        ) {
          this.mainContactOptions = [
            { text: "Select One", value: null, disabled: true },
            { text: "Yes", value: true, disabled: true },
            { text: "No", value: false, selected: true }
          ];
        } else if (this.main_contact_id.length < 3) {
          this.mainContactOptions = [
            { text: "Select One", value: null },
            { text: "Yes", value: true },
            { text: "No", value: false }
          ];
        }
      }
    },
    CUSTOMER_DETAIL_DATA: function() {
      this.customer.fullname =
        this.CUSTOMER_DETAIL_DATA.first_name +
        " " +
        this.CUSTOMER_DETAIL_DATA.last_name;
      this.customer.email = this.CUSTOMER_DETAIL_DATA.email;
      this.customer.phone = this.CUSTOMER_DETAIL_DATA.profile.phone;
      let age = moment().diff(
        this.CUSTOMER_DETAIL_DATA.profile.dob,
        "years",
        false
      );
      this.underAge = age > 14 || age === 14 ? false : true;
    },
    RESIDENT_DETAIL_DATA: function() {
      this.customer_list = [];
      this.edit_id = this.RESIDENT_DETAIL_DATA.id;
      this.selectedCustomer = this.RESIDENT_DETAIL_DATA.resident.id;

      let tmp_dict = {};
      (tmp_dict["username"] = this.RESIDENT_DETAIL_DATA.resident.username),
        (tmp_dict["id"] = this.RESIDENT_DETAIL_DATA.resident.id);
      tmp_dict["name"] =
        this.RESIDENT_DETAIL_DATA.resident.first_name +
        " " +
        this.RESIDENT_DETAIL_DATA.resident.last_name;
      this.customer_list.push(tmp_dict);
      this.disableResidentOption = true;

      this.mainOwner = this.RESIDENT_DETAIL_DATA.isOwner;
      this.tenant = this.RESIDENT_DETAIL_DATA.isTenant;
      if (this.RESIDENT_DETAIL_DATA.resident_movein !== null) {
        this.RESIDENT_DETAIL_DATA.resident_movein = utils.formatSqlDate(this.RESIDENT_DETAIL_DATA.resident_movein, null, "YYYY-MM-DD");
      }
      if (this.RESIDENT_DETAIL_DATA.resident_moveout !== null) {
        this.RESIDENT_DETAIL_DATA.resident_moveout = utils.formatSqlDate(this.RESIDENT_DETAIL_DATA.resident_moveout, null, "YYYY-MM-DD");
      }

      this.mainContact = this.RESIDENT_DETAIL_DATA.isMainContact;
      this.isOwner = this.RESIDENT_DETAIL_DATA.isOwner;
      this.isTenant = this.RESIDENT_DETAIL_DATA.isTenant;
      this.date_move_in = this.RESIDENT_DETAIL_DATA.resident_movein;
      this.date_move_out = this.RESIDENT_DETAIL_DATA.resident_moveout;
      this.e_figure = this.RESIDENT_DETAIL_DATA.start_efigure;
      this.w_figure = this.RESIDENT_DETAIL_DATA.start_wfigure;
      this.residence_status = this.RESIDENT_DETAIL_DATA.resident_status;
      if (this.RESIDENT_DETAIL_DATA.relationship_to !== null) {
        this.selectedCustomerRelationTo = this.RESIDENT_DETAIL_DATA.relationship_to.id;
      }
      this.relationship = this.RESIDENT_DETAIL_DATA.relationship;
      this.relationship_note = this.RESIDENT_DETAIL_DATA.relationship_note;
      if (this.isOwner == true || this.isTenant == true) {
        this.disableEFigure = false;
        this.disableWFigure = false;
      }
      if (this.mainOwner == true) {
        this.owner_detail["id"] = this.RESIDENT_DETAIL_DATA.resident.id;
        (this.owner_detail[
          "username"
        ] = this.RESIDENT_DETAIL_DATA.resident.username),
          (this.owner_detail[
            "resident_status"
          ] = this.RESIDENT_DETAIL_DATA.resident_status);
        if (this.relation_to_owner_list.includes(this.selectedCustomer)) {
          // 2 - Left
          // 1 - Staying
          if (this.residence_status === 1) {
            this.disableOwnerOption = true;
          } else if (this.residence_status === 2) {
            this.disableOwnerOption = false;
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "APARTMENT_DETAIL_DATA",
      "GET_CUSTOMER_DATA",
      "CUSTOMER_DETAIL_DATA",
      "GET_RESIDENT_DATA",
      "RESIDENT_DETAIL_DATA"
    ])
  },
  created() {
    let data = {
      params: {
        page: 1
      }
    };
    this.GET_CUSTOMER_LIST(data);
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_APARTMENT_DETAIL",
      "GET_CUSTOMER_LIST",
      "GET_CUSTOMER_DETAIL",
      // "ADD_RESIDENT",
      "GET_RESIDENT_LIST",
      "GET_RESIDENT_DETAIL"
    ]),
    disableWaterElectric: function() {
      if (this.mainOwner == true || this.tenant == true) {
        this.disableEFigure = false;
        this.disableWFigure = false;
      } else {
        this.disableEFigure = true;
        this.disableWFigure = true;
      }
    },

    onChangeServiceUsage: function() {
      //
    },

    onResidentCancel: function() {
      this.relationship_to_customer_list = [];
      this.$emit("residentAdd-cancel", {});
    },
    mainOwnerSelected: function() {
      this.disableWaterElectric();
      if (this.mainOwner === true) {
        this.mainContact = true;
        this.mainContactOptions = [
          { text: "Select One", value: null, disabled: true },
          { text: "Yes", value: true, selected: true },
          { text: "No", value: false, disabled: true }
        ];
        this.tenantOptions = [];
        this.disableTenantOption = true;
      } else if (this.mainOwner === false) {
        this.mainContactOptions = [
          { text: "Select One", value: null },
          { text: "Yes", value: true },
          { text: "No", value: false }
        ];
        this.tenantOptions = [
          { text: "Select One", value: null },
          { text: "Yes", value: true },
          { text: "No", value: false }
        ];
        this.disableTenantOption = false;
      }
    },
    tenantSelected: function() {
      this.disableWaterElectric();
      if (this.tenant === true) {
        this.mainContact = true;
        this.mainContactOptions = [
          { text: "Select One", value: null, disabled: true },
          { text: "Yes", value: true },
          { text: "No", value: false, disabled: true }
        ];
      } else if (this.tenant === false) {
        this.mainContactOptions = [
          { text: "Select One", value: null },
          { text: "Yes", value: true },
          { text: "No", value: false }
        ];
      }
    },
    onChangeResidentStatus: function() {
      if (this.selectedCustomer === this.owner_detail["id"]) {
        if (!this.relation_to_owner_list.includes(this.selectedCustomer)) {
          // rental status = 1 (Staying), 2(Leaving)
          if (this.residence_status === 2) {
            this.disableOwnerOption = false;
            // console.log('owner has relation with others and status is leaving')
          } else if (this.resident_status === 1) {
            this.disableOwnerOption = true;
            // reset isOwner to "Yes" because status is "staying"
            this.mainOwner = true;
            this.mainOwnerSelected();
          } else {
            this.disableOwnerOption = true;
            // reset isOwner to "Yes" because status is "staying"
            this.mainOwner = true;
            this.mainOwnerSelected();
          }
        }
      }
    },

    validateData: function() {
      let validatedResult = true;
      for (let key in this.final_data) {
        if (key === "resident") {
          if (
            this.final_data["resident"] === null ||
            this.final_data["resident"] === ""
          ) {
            validatedResult = false;
          } else {
            validatedResult = true;
          }
        } else {
          //
        }
      }
      return validatedResult;
    },

    onResidentSubmit: function(event) {
      if (
        this.date_move_out === "Invalid Date" ||
        this.date_move_out === "" ||
        this.date_move_out === null
      ) {
        this.date_move_out = null;
      } else {
        this.date_move_out = utils.formatSqlDate(this.date_move_out, null, "YYYY-MM-DDThh:mm:ss");
      }
      if (
        this.date_move_in === "Invalid date" ||
        this.date_move_in === "" ||
        this.date_move_in === null
      ) {
        this.date_move_in = null;
      } else {
        this.date_move_in = utils.formatSqlDate(this.date_move_in, null, "YYYY-MM-DDThh:mm:ss");
      }
      if (this.hasOwner === true) {
        this.mainOwner = false;
      }
      if (this.hasTenant === true) {
        this.tenant = false;
      }
      if (this.mainOwner === true) {
        this.tenant = false;
      }
      if (
        this.main_contact_id.length === 3 ||
        this.main_contact_id.length > 3
      ) {
        this.mainContact = false;
      }

      this.final_data = {
        isMainContact: this.mainContact,
        isOwner: this.mainOwner,
        isTenant: this.tenant,
        resident_movein: this.date_move_in, // utils.formatSqlDate(this.date_move_in, null, 'YYYY-MM-DDThh:mm:ss'),
        resident_moveout: this.date_move_out, // utils.formatSqlDate(this.date_move_out, null, 'YYYY-MM-DDThh:mm:ss'),
        start_efigure: this.e_figure,
        start_wfigure: this.w_figure,
        resident_status: this.residence_status,
        relationship: this.relationship,
        relationship_note: this.relationship_note,
        apartment: this.apartment.id,
        resident: this.selectedCustomer,
        relationship_to: this.selectedCustomerRelationTo
      };

      let result = this.validateData();
      if (result) {
        this.relationship_to_customer_list = [];
        if (this.item.actionType === 0) {
          let data = this.final_data;
          this.$emit("residentAdd-submit", data);
        } else {
          let data = {};
          this.final_data["id"] = this.edit_id;
          data = this.final_data;
          this.$emit("residentEdit-submit", data);
        }
      } else {
        alert("Pls fill all required fields!");
      }
    }
  },
  mounted() {
    let id = this.$route.params.id;
    if (this.item.actionType === 0) {
      this.apartment.id = id;
      this.pagetitle = "apartment.add_resident";
      this.GET_APARTMENT_DETAIL({ id: id });
      const data = {
        params: {
          page: 1,
          apartment: id
        }
      };
      this.GET_RESIDENT_LIST(data);
    } else if (this.item.actionType === 1) {
      this.apartment.id = id;
      this.pagetitle = "apartment.edit_resident";
      this.GET_APARTMENT_DETAIL({ id: id });
      const data = {
        params: {
          page: 1,
          apartment: id
        }
      };
      this.GET_RESIDENT_LIST(data);
      this.GET_RESIDENT_DETAIL({ id: this.item.id });
    } else {
      //
    }
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Apartment/ResidentAdd.vue